<div class="errwrap">
  <div class="errdiv1" id="errs"></div>
</div>
<div *ngIf="actionmode == 'Add' || actionmode == 'Edit'" class="searchdiv">
  <div class="card screen-wrapper">
    <div class="header headerdiv">
      <h1 class="screen-title">{{ screentitle }}</h1>
      <div class="button-wrapper bothbuttdiv2">
        <div *ngIf="actionmode == 'Add' || actionmode == 'Edit'" class="btn back-button button-margin">
          <button class="btn btn-primary commonbutt" type="button" (click)="submitcancelData()"
            [disabled]="!(startrangeflag && endrangeflag && chargeflag)">
            <em class="fa fa-check"></em>&nbsp;Submit
          </button>

          <button class="btn btn-danger commonbutt" (click)="searchForm()" type="button">
            <em class="fa fa-times"></em>&nbsp;Close
          </button>
        </div>
      </div>
    </div>

    <div class="card-body">
      <div class="row">
        <div class="col-md-12">
          <div class="form-div">
            <div class="row">
              <div class="m-portlet">
                <div style="padding: 2% 2% 2% 2%">
                  <div class="col-lg-3">
                    <label>Label</label>
                    <input type="text" class="form-control m-input" [(ngModel)]="screen_details.Band_Name"
                      (input)="namecheck()" placeholder="Enter Label">
                    <div class="err" id="nameErr" style="height:30px"></div>
                  </div>
                  <div class="col-lg-3">
                    <label>Lower Limit (%)</label>
                    <input type="text" class="form-control m-input" [(ngModel)]="screen_details.Start_Range"
                      (input)="startrange()" placeholder="Enter Lower Limit (%)">
                    <div class="err" id="startErr" style="height:30px"></div>
                  </div>
                  <div class="col-lg-3">
                    <label>Upper Limit (%)</label>
                    <input type="text" class="form-control m-input" [(ngModel)]="screen_details.End_Range "
                      (input)="endrange()" placeholder="Enter Upper Limit (%)">
                    <div class="err" id="endErr" style="height:30px"></div>
                  </div>
                  <div class="col-lg-3">
                    <label>Cancellation Charge</label>
                    <input type="text" class="form-control m-input" [(ngModel)]="screen_details.Cancellation_Charge"
                      (input)="chargerange()" placeholder="Enter Cancellation Charge">
                    <div class="err" id="chargeErr" style="height:30px"></div>
                  </div>
                  <div *ngIf="editFlag==true">
                    <button class="btn btn-danger  commonbutt color" type="button" (click)="deleteData()">
                      Delete
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- view Details -->
<div [hidden]="!viewpage" class="tdive">
  <div *ngIf="actionmode == 'view'" class="searchdiv">
    <div class="card screen-wrapper">
      <div style="border-bottom:1px solid #ddd9d9;margin-bottom: 15px; ">
        <h4 class="screen-title">{{ screentitle }}</h4>
        <div class="button-wrapper bothbuttdiv2">

          <button style="margin-top: 8px" class="btn btn-danger commonbutt" (click)="searchForm()" type="button">
            <em class="fa fa-times"></em>&nbsp;Close
          </button>

        </div>
      </div>
    </div>

    <table aria-describedby="cancellationMasterDetails" class="viewtable">
      <div *ngFor="let q of EditData">
        <tr>
          <th scope="col">
            <span class="vlbl">Label</span>
          </th>
          <td>
            <span class="vVal">{{ q.BAND_NAME }}</span>
          </td>
        </tr>
        <tr>
          <th scope="col">
            <span class="vlbl">Lower Limit (%)</span>
          </th>
          <td>
            <span class="vVal">{{ q.START_RANGE }}</span>
          </td>
        </tr>

        <tr>
          <th scope="col">
            <span class="vlbl">Upper Limit (%)</span>
          </th>
          <td>

            <span class="vVal">{{ q.END_RANGE }}</span>

          </td>
        </tr>
        <tr>
          <th scope="col">
            <span class="vlbl">Cancellation Charge</span>
          </th>
          <td>

            <span class="vVal">{{ q.CANCELLATION_CHARGE }}</span>

          </td>
        </tr>
      </div>
    </table>
  </div>
</div>
<!-- End -->
<div [hidden]="viewpage" *ngIf="actionmode != 'Add' && actionmode != 'Edit' && actionmode != 'View'" class="searchdiv">
  <div class="headerdiv">
    <h1>Cancellation Search</h1>
    <div class="bothbuttdiv">
      <button class="btn btn-primary commonbutt" type="button" (click)="addForm()">
        <em class="fa fa-plus-circle"></em>&nbsp;Add New
      </button>
    </div>
  </div>
  <div class="card-body">
    <div class="row">
      <div class="col-md-12">
        <div class="form-div">
          <div class="row">
            <div class="m-portlet">
              <div>
                <div>
                  <div class="wr15">
                    <div class="instruct">
                      <div class="int1" style="margin-left: 17px">
                        <span class="inst" style="font-size: 12px"><strong> Instructions </strong></span>
                        <br />


                        <span class="txt">
                          1. Select at least one value out of Lower Limit (%),Upper Limit (%).
                          <!-- ,Cabin Class. -->

                        </span>
                        <br />
                        <span class="txt">
                          2. You can also use a combination of the given fields to search </span>
                        <br />
                        <span></span>
                      </div>
                    </div>
                    <div class="col-lg-3">
                      <label>Label</label>
                      <input type="text" class="form-control m-input" [(ngModel)]="search_details.Bucket_Name"
                        placeholder="Enter Label">
                    </div>
                    <div class="col-lg-3">
                      <label>Lower Limit (%)</label>
                      <input type="text" class="form-control m-input" [(ngModel)]="search_details.Start_Range"
                        placeholder="Enter Lower Limit (%)">
                      <div class="err" id="startErr"></div>
                    </div>
                    <div class="col-lg-3">
                      <label>Upper Limit (%)</label>
                      <input type="text" class="form-control m-input" [(ngModel)]="search_details.End_Range"
                        placeholder="Enter Upper Limit (%)">
                    </div>
                    <div class="btn clear-button button-margin">
                      <button style="margin-top: 20px;" class="btn btn-primary commonbutt" (click)="searchData()"
                        type="button">
                        <em class="fa fa-search "></em>&nbsp;Search
                      </button>
                    </div>
                  </div>
                  <br />

                  <div *ngIf="searchresult" class="reportstatus" [hidden]="searchlist">
                    <table aria-describedby="cancellationMasterSearchData" class="table table-striped"
                      [mfData]="searchtabledata" [mfRowsOnPage]="5">

                      <tr>
                        <th scope="col" style="width: 10%">Action
                        </th>
                        <th scope="col" style="width: 20%">Label
                        </th>
                        <th scope="col" style="width: 20%"> Lower Limit (%)
                        </th>

                        <th scope="col" style="width: 20%">
                          Upper Limit (%)
                        </th>
                        <th scope="col" style="width: 20%">
                          Cancellation Charge
                        </th>

                      </tr>
                      <tr *ngFor="let q of (searchtabledata
                        | paginate: { itemsPerPage: 10, currentPage: p })">
                        <td>
                          <button class="btn btn-default btn-circle" type="button" (click)="showFormData(q,1)">
                            <em class="fa fa-eye"></em>
                          </button>

                          <button class="btn btn-default btn-circle" type="button" (click)="showFormData(q,2)">
                            <em class="fa fa-pencil"></em>
                          </button>

                        </td>

                        <td>
                          <span class="vVal">{{ q.BAND_NAME }}</span>
                        </td>
                        <td>
                          <span class="vVal">{{ q.START_RANGE }}</span>
                        </td>
                        <td>
                          <span class="vVal">{{ q.END_RANGE }}</span>
                        </td>
                        <td>
                          <span class="vVal">{{ q.CANCELLATION_CHARGE }}</span>
                        </td>

                      </tr>

                      <tfoot>
                        <tr>
                          <td colspan="4">

                            <pagination-controls (pageChange)="p = $event"></pagination-controls>
                          </td>
                        </tr>
                      </tfoot>

                    </table>
                  </div>
                  <div *ngIf="loader">
                    <div style="margin:auto; text-align: center">
                      <img
                        src="https://vignette.wikia.nocookie.net/lego/images/b/b4/Loading_Animation.gif/revision/latest/scale-to-width-down/480?cb=20120528032206"
                        width="8%" height="8%" alt="Loader" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</div>